import React, { memo } from "react";

export default memo(() => (
  <section className="section has-text-centered">
    <h1 className="title"> Page Not Found"</h1>
  </section>
));
